module.exports = __webpack_public_path__ + "img/chips2000.a805d29f.png";